module.exports = __webpack_public_path__ + "static/imgoutline-missing-d439f49989feb89029f2b5e708ec004c.png";